/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DateTime } from './DateTime';
export type ConfirmSeminarPaymentPayload = {
    paidAt: DateTime;
    paymentType: ConfirmSeminarPaymentPayload.paymentType;
    taxRate: number;
    price: number;
};
export namespace ConfirmSeminarPaymentPayload {
    export enum paymentType {
        ONLINE = 'online',
        CASH = 'cash',
        INVOICE = 'invoice',
    }
}

